import cloneDeep from 'lodash/cloneDeep';
import fields from '../Field.constants';
import { onHold } from 'Common/Utils/regexPatterns';

const getUpdatedData = (refinedAppointments, updates) => {
    return updates.reduce(applyUpdate, cloneDeep(refinedAppointments));
};

const applyUpdate = (updatedAppointments, update) => {
    if (update.field === fields.ReadyForApproval && onHold.test(update.value)) {
        const appointments = updateFns[fields.ContractReleaseDate](updatedAppointments, { value: null });
        return updateFns[update.field](appointments, update);
    }
    return updateFns[update.field](updatedAppointments, update);
};

const templateUpdate = (appointments, update) => appointments.map(appointment => ({...appointment, template: update.value }));
const readyForApprovalUpdate = (appointments, update) => appointments.map(appointment => ({...appointment, readyForApproval: update.value }));
const releaseDateUpdate = (appointments, update) => appointments.map(appointment => ({...appointment, contract: {...appointment.contract, releaseDate: update.value }}));
const endDateUpdate = (appointments, update) => appointments.map(appointment => ({...appointment, contract: {...appointment.contract, endDate: update.value }}));
const teamEmailUpdate = (appointments, update) => appointments.map(appointment => ({...appointment, teamEmail: update.value }));

const updateFns = {
    [fields.Template]: templateUpdate,
    [fields.ReadyForApproval]: readyForApprovalUpdate,
    [fields.ContractReleaseDate]: releaseDateUpdate,
    [fields.ContractEndDate]: endDateUpdate,
    [fields.TeamEmail]: teamEmailUpdate,
};

export default getUpdatedData;
